import actions from './action';
import mutations from './mutations';
export const state = { termsConditions: undefined, footerElems: undefined };
const namespaced = true;
const footerModule = { state, actions, mutations, namespaced };
export default footerModule;
